import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import StarIcon from '@mui/icons-material/Star';
import SendIcon from '@mui/icons-material/Send';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import axios from 'axios';
import {
  FormGroup, FormControlLabel, Checkbox, Button, Switch, Box,
  Alert, AlertTitle, Tooltip, Chip, Typography, Paper, Modal,
} from '@mui/material';
import { WithContext as ReactTags } from 'react-tag-input';
import { useNotification } from '../context/NotificationContext';
import { styled } from '@mui/material/styles';
import { tooltipClasses } from '@mui/material/Tooltip';

const isLocal = window.location.hostname === 'localhost';
const apiPrefix = isLocal ? '' : '/api';

const SectionHeader = ({ title }) => (
  <Typography
    variant="h6"
    sx={{ fontWeight: 600, color: '#2c3e50', borderBottom: '2px solid #0079bf', pb: 0.5, fontSize: '1rem', mt: 4, mb: 1, display: 'inline-block' }}
  >
    {title}
  </Typography>
);

const modalPaperSx = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 420,
  borderRadius: 2,
  p: 4,
};

const ResultFilterScreen = () => {

    const location = useLocation();
    const navigate = useNavigate();
    const { user } = useAuth();
    const { showSuccess } = useNotification();

    const [confirmSaveEmailModalOpen, setConfirmSaveEmailModalOpen] = useState(false);

    useEffect(() => { document.title = 'Rezultati | Media Scanner'; }, []);

    const handleGoBack = () => {
        navigate('/main');
    };

    const [selectedItems, setSelectedItems] = useState(location.state && location.state.findings ? location.state.findings : []);

    const KeyCodes = {
        comma: 188,
        enter: 13,
    };
    const delimiters = [KeyCodes.comma, KeyCodes.enter];

    const initialState = Object.fromEntries(selectedItems.map((item) => [item.url, true]));

    const [sourceCheckboxes, setSourceCheckboxes] = useState({});

    const [checkboxValues, setCheckboxValues] = useState(initialState);

    const handleCheckboxChange = (event, item) => {
        setCheckboxValues({
            ...checkboxValues,
            [event.target.name]: event.target.checked,
        });

        const allItemsInSource = selectedItems.filter((i) => i.source === item.source);
        const isAllChecked = allItemsInSource.every((i) => i.url === event.target.name ? event.target.checked : checkboxValues[i.url]);
        const isNoneChecked = allItemsInSource.every((i) => i.url === event.target.name ? !event.target.checked : !checkboxValues[i.url]);

        setSourceCheckboxes({
            ...sourceCheckboxes,
            [item.source]: isNoneChecked ? false : isAllChecked ? true : 'indeterminate',
        });
    };

    const handleSourceCheckboxChange = (source) => {
        const isCurrentlyChecked = sourceCheckboxes[source];
        const newCheckState = !isCurrentlyChecked;

        const newCheckboxValues = { ...checkboxValues };
        selectedItems.forEach((item) => {
            if (item.source === source) {
                newCheckboxValues[item.url] = newCheckState;
            }
        });

        setCheckboxValues(newCheckboxValues);
        setSourceCheckboxes({
            ...sourceCheckboxes,
            [source]: newCheckState,
        });
    };

    const [checkboxAll, setCheckboxAll] = useState(true)

    const handleCheckboxAll = (event) => {
        const newCheckState = event.target.checked;
        const newCheckboxValues = {};
        const newSourceCheckboxes = {};

        selectedItems.forEach((item) => {
            newCheckboxValues[item.url] = newCheckState;
            newSourceCheckboxes[item.source] = newCheckState;
        });

        setCheckboxValues(newCheckboxValues);
        setCheckboxAll(newCheckState);
        setSourceCheckboxes(newSourceCheckboxes);
    };

    const userId = user?.user_id ?? '';
    const [allEmailAddresses, setAllEmailAddresses] = React.useState([]);

    useEffect(() => {
        const initialCheckboxValues = {};
        const initialSourceCheckboxes = {};

        selectedItems.forEach((item) => {
            initialCheckboxValues[item.url] = true;
            initialSourceCheckboxes[item.source] = true;
        });

        setCheckboxValues(initialCheckboxValues);
        setSourceCheckboxes(initialSourceCheckboxes);
    }, [selectedItems]);

    useEffect(() => {
        if (!userId) return;
        fetchUserDefaultEmailAddresses(userId);
    }, [userId]);

    const fetchUserDefaultEmailAddresses = async (userId) => {
        try {
          const response = await axios.post(apiPrefix + '/get_user_default_email_addresses_by_user_id', {
            user_id: userId,
          }, {
            withCredentials: true,
          });
          setAllEmailAddresses(response.data);
        } catch (error) {
          console.error('Error getting terms by user_id:', error);
        }
    };

    const [emailSuggestions] = React.useState([
        {id: 'josipabnm@gmail.com', text: 'josipabnm@gmail.com'},
        {id: 'josipa.strkalj@rmf.hr', text: 'josipa.strkalj@rmf.hr'},
        {id: 'marko.strkalj@gmail.com', text: 'marko.strkalj@gmail.com'},
        {id: 'bnmjosipa@yahoo.com', text: 'bnmjosipa@yahoo.com'},
    ]);

    const handleSubmit = (e) => {
        e.preventDefault();
        const itemsForSending = selectedItems.filter(item => checkboxValues[item.url]);
        sendEmails(itemsForSending);
    };

    const [emailAddressesSetChangeHappened, setEmailAddressesSetChangeHappened] = useState(false);

    const handleDeleteEmail = (i) => {
        setAllEmailAddresses(allEmailAddresses.filter((tag, index) => index !== i));
        setEmailAddressesSetChangeHappened(true)
    };

    const handleAdditionEmail = (tag) => {
        setAllEmailAddresses([...allEmailAddresses, tag]);
        setEmailAddressesSetChangeHappened(true)
    };

    const handleDragEmail = (tag, currPos, newPos) => {
        const newTags = allEmailAddresses.slice();
        newTags.splice(currPos, 1);
        newTags.splice(newPos, 0, tag);
        setAllEmailAddresses(newTags);
    };

    const handleTagClickEmail = (index) => {};

    const [switchCheckedEmail, setSwitchCheckedEmail] = React.useState(true);

    const handleSwitchChangeEmail = (event) => {
        setSwitchCheckedEmail(event.target.checked);
        if (event.target.checked) {
            fetchUserDefaultEmailAddresses(userId);
        } else {
            setAllEmailAddresses([])
        }
    };

    function handleSetDefaultEmailAddresses() {
        var defaultEmailAddresses = [];
        for (let i=0; i<allEmailAddresses.length; i++) {
            defaultEmailAddresses.push(allEmailAddresses[i].text);
        }
        axios.post(apiPrefix + '/setDefaultEmailAddresses', {'default_email_addresses': defaultEmailAddresses})
        .then((response) => {
          if (response.status === 200) {
            setEmailAddressesSetChangeHappened(false);
          } else {
            setEmailAddressesSetChangeHappened(true);
            console.error("Error in API call:", response.data);
          }
        })
    }

    const sendButtonEnabled = () => {
        return Object.values(checkboxValues).some((value) => value === true) && (allEmailAddresses.length > 0);
    }

    const [errorMessage, setErrorMessage] = useState("");
    const [searchStatus, setSearchStatus] = useState('');
    const [open, setModalOpen] = React.useState(false);

    function handleCloseModal(){
        setModalOpen(false);
    }

    function sendEmails(findings) {
        var payload = {
        "emailAddresses": allEmailAddresses.map(({ text }) => text),
        "findings": findings.map(({ title, url, source, matched_terms, translated_title }) => ({
            title, url, source, matched_terms, translated_title
        })),
        }
        axios.post(apiPrefix + '/sendEmails', { payload }, { withCredentials: true })
        .then((response) => {
            if (response.status === 200) {
            showSuccess('Rezultati su u inboxu!');
            }
        })
        .catch((error) => {
            console.error(error);
            setErrorMessage(error.response?.data?.detail || error.message)
            setSearchStatus("Failed");
            setModalOpen(true);
        });
    }

    let currentSource = null;

    // HTML Tooltip
    const HtmlTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} classes={{ popper: className }} />
      ))(({ theme }) => ({
        [`& .${tooltipClasses.tooltip}`]: {
          backgroundColor: '#f5f5f9',
          color: 'rgba(0, 0, 0, 0.87)',
          maxWidth: 220,
          fontSize: theme.typography.pxToRem(12),
          border: '1px solid #dadde9',
        },
      }));

    const alertModalContent = {
        Complete: (
            <Paper elevation={8} sx={modalPaperSx}>
                <Alert severity="success"><AlertTitle>Gotovo!</AlertTitle>Pretraga je završila — <strong>Rezultati su u inboxu!</strong></Alert>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                    <Button variant="outlined" onClick={handleCloseModal}>Zatvori</Button>
                </Box>
            </Paper>
        ),
        Failed: (
            <Paper elevation={8} sx={modalPaperSx}>
                <Alert severity="error"><AlertTitle>Slanje e-maila nije uspjelo</AlertTitle>Poruka nije isporučena. Provjerite e-mail adrese i pokušajte ponovo.</Alert>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                    <Button variant="outlined" onClick={handleCloseModal}>Zatvori</Button>
                </Box>
            </Paper>
        ),
    }[searchStatus] || (
        <Paper elevation={8} sx={modalPaperSx}>
            <Alert severity="error"><AlertTitle>Dogodila se nepoznata greška</AlertTitle></Alert>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                <Button variant="outlined" onClick={handleCloseModal}>Zatvori</Button>
            </Box>
        </Paper>
    );

    const checkedCount = Object.values(checkboxValues).filter(v => v).length;

    return (
        <Box sx={{ minHeight: '100vh', backgroundColor: '#f5f7fa' }}>
            <form onSubmit={handleSubmit}>
                <Box sx={{ maxWidth: 900, mx: 'auto', px: 2, py: 3 }}>
                    {/* Page header */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
                        <Typography variant="h5" sx={{ fontWeight: 700, color: '#2c3e50' }}>
                            Rezultati pretrage
                        </Typography>
                        <Chip
                            label={`${selectedItems.length} ${selectedItems.length === 1 ? 'rezultat' : 'rezultata'}`}
                            size="small"
                            sx={{ fontWeight: 600, backgroundColor: '#e3f2fd', color: '#0079bf' }}
                        />
                    </Box>

                    {/* Articles section */}
                    <Paper sx={{ p: 3, borderRadius: 2, mb: 3 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
                            <Typography variant="body2" sx={{ fontWeight: 600, color: '#2c3e50' }}>
                                Odaberi članke za distribuciju
                            </Typography>
                            <Chip
                                label={`${checkedCount} / ${selectedItems.length} odabrano`}
                                size="small"
                                variant="outlined"
                                color="primary"
                            />
                        </Box>

                        {/* Term count chips */}
                        {selectedItems.length > 0 && (() => {
                            const termCounts = {};
                            selectedItems.forEach(item => {
                                const terms = item.matched_terms || (item.first_term_found ? [item.first_term_found] : []);
                                terms.forEach(term => {
                                    termCounts[term] = (termCounts[term] || 0) + 1;
                                });
                            });
                            return (
                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mb: 2 }}>
                                    {Object.entries(termCounts).filter(([, count]) => count > 0).map(([term, count]) => (
                                        <Chip key={term} label={`${term}  ${count}`} size="small" variant="outlined" color="primary" />
                                    ))}
                                </Box>
                            );
                        })()}

                        {selectedItems.length === 0 ? (
                            <Typography variant="body1" color="text.secondary" sx={{ py: 3, textAlign: 'center' }}>
                                Nema rezultata za odabrane pojmove i portale.
                            </Typography>
                        ) : (
                            <FormGroup>
                                <FormControlLabel
                                    control={<Checkbox checked={checkboxAll} onChange={handleCheckboxAll} />}
                                    label={<Typography variant="body2" sx={{ fontWeight: 600 }}>Svi portali</Typography>}
                                    sx={{ mb: 1 }}
                                />

                                {selectedItems.map((item) => {
                                    const { url, title, source, matched_terms, first_term_found } = item;
                                    const displayTerms = matched_terms || (first_term_found ? [first_term_found] : []);
                                    const isNewSource = source !== currentSource;
                                    currentSource = source;

                                    return (
                                        <React.Fragment key={url}>
                                            {isNewSource && (
                                                <Box sx={{ mt: 2, mb: 0.5 }}>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={sourceCheckboxes[source] === true}
                                                                indeterminate={sourceCheckboxes[source] === 'indeterminate'}
                                                                onChange={() => handleSourceCheckboxChange(source)}
                                                                name={source}
                                                            />
                                                        }
                                                        label={
                                                            <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#2c3e50' }}>
                                                                {source}
                                                            </Typography>
                                                        }
                                                    />
                                                </Box>
                                            )}

                                            <Box sx={{ display: 'flex', alignItems: 'flex-start', pl: 2, mb: 1.5 }}>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            name={item.url}
                                                            checked={checkboxValues[item.url]}
                                                            onChange={(e) => handleCheckboxChange(e, item)}
                                                            size="small"
                                                        />
                                                    }
                                                    label={
                                                        <Box>
                                                            <Typography variant="body2" sx={{ fontSize: '16px' }}>{title}</Typography>
                                                            {item.translated_title && (
                                                                <Typography variant="body2" sx={{ fontSize: '14px', fontStyle: 'italic', color: '#666', mt: 0.3 }}>
                                                                    {item.translated_title}
                                                                </Typography>
                                                            )}
                                                            <Typography
                                                                variant="caption"
                                                                component="a"
                                                                href={url}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                sx={{ color: '#0079bf', '&:visited': { color: '#7b4f9d' }, '&:hover': { textDecoration: 'underline' } }}
                                                            >
                                                                {url}
                                                            </Typography>
                                                        </Box>
                                                    }
                                                    sx={{ flex: 1, alignItems: 'flex-start', mr: 0 }}
                                                />
                                                <HtmlTooltip
                                                    title={
                                                        <Typography variant="body2">
                                                            {displayTerms.length > 1 ? 'Pojmovi' : 'Pojam'}: {displayTerms.join(', ')}
                                                        </Typography>
                                                    }
                                                    placement="right"
                                                    arrow
                                                >
                                                    <HelpOutlineIcon sx={{ fontSize: 18, color: 'text.secondary', mt: 1, cursor: 'pointer' }} />
                                                </HtmlTooltip>
                                            </Box>
                                        </React.Fragment>
                                    );
                                })}
                            </FormGroup>
                        )}
                    </Paper>

                    {/* Email section */}
                    <Paper sx={{ p: 3, borderRadius: 2, mb: 3 }}>
                        <SectionHeader title="Email adrese za dostavu rezultata" />
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1, mt: 1 }}>
                            <Typography variant="body2" sx={{ fontWeight: 600, color: '#2c3e50' }}>
                                Koristi spremljene adrese:
                            </Typography>
                            <Switch
                                size="small"
                                onChange={handleSwitchChangeEmail}
                                checked={switchCheckedEmail}
                                inputProps={{ 'aria-label': 'controlled' }}
                            />
                        </Box>
                        <ReactTags
                            tags={allEmailAddresses}
                            suggestions={emailSuggestions}
                            delimiters={delimiters}
                            handleDelete={handleDeleteEmail}
                            handleAddition={handleAdditionEmail}
                            handleDrag={handleDragEmail}
                            handleTagClick={handleTagClickEmail}
                            inputFieldPosition="bottom"
                            placeholder='Unesi email adresu, zatim zarez ili Enter'
                            autocomplete
                            editable
                        />
                        <Box sx={{ mt: 1.5 }}>
                            <Tooltip title="Spremi trenutne email adrese kao zadane za buduće pretrage">
                                <span>
                                    <Button
                                        variant="outlined"
                                        size="small"
                                        startIcon={<StarIcon />}
                                        onClick={() => setConfirmSaveEmailModalOpen(true)}
                                        disabled={!emailAddressesSetChangeHappened}
                                        sx={{ textTransform: 'none' }}
                                    >
                                        Zapamti email adrese
                                    </Button>
                                </span>
                            </Tooltip>
                        </Box>
                    </Paper>

                    {/* Action buttons */}
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Button
                            variant="outlined"
                            startIcon={<ArrowBackIosNewIcon />}
                            onClick={handleGoBack}
                        >
                            Natrag
                        </Button>
                        <Button
                            variant="contained"
                            type="submit"
                            disabled={!sendButtonEnabled()}
                            startIcon={<SendIcon />}
                            size="large"
                        >
                            Pošalji
                        </Button>
                    </Box>
                </Box>
            </form>

            {/* Status modal */}
            <Modal open={open} aria-labelledby="modal-modal-title">
                {alertModalContent}
            </Modal>

            {/* Confirm save email modal */}
            <Modal
                open={confirmSaveEmailModalOpen}
                onClose={() => setConfirmSaveEmailModalOpen(false)}
                aria-labelledby="confirm-email-modal-title"
            >
                <Paper elevation={8} sx={modalPaperSx}>
                    <Typography variant="h6" sx={{ fontWeight: 600, color: '#2c3e50', mb: 1 }}>
                        Promjena email adresa
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                        Jeste li sigurni da želite promijeniti spremljene email adrese?
                    </Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                        <Button
                            variant="outlined"
                            onClick={() => {
                                fetchUserDefaultEmailAddresses(userId);
                                setConfirmSaveEmailModalOpen(false);
                            }}
                        >
                            Odustani
                        </Button>
                        <Button
                            variant="contained"
                            onClick={() => {
                                handleSetDefaultEmailAddresses();
                                setConfirmSaveEmailModalOpen(false);
                            }}
                        >
                            Da, promijeni
                        </Button>
                    </Box>
                </Paper>
            </Modal>
        </Box>
    );
};

export default ResultFilterScreen;
